<main>
  <loading-overlay [isLoading]="loading()"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'CustomerOrderReport_Page_Title' | translateWF: 'Customer Order Reports' }}</h1>
      </div>
    </div>

    <form [formGroup]="reportForm" class="report-form">
      <p-panel [header]="'CustomerOrderReport_Title' | translateWF: 'Customer Orders with Dispatches'" [toggleable]="true">
        <ng-template pTemplate="icons">
          <p-button
            [label]="'CustomerOrderReport_Generate_Button' | translateWF: 'Generate Report'"
            icon="pi pi-download"
            (onClick)="generateReport()"
            [outlined]="true"
            [loading]="loading()"
            [disabled]="reportForm.invalid || loading()"
          />
        </ng-template>

        <p-card>
          <p class="text-sm text-color-tertiary mb-4">
            {{
              'CustomerOrderReport_Description'
                | translateWF
                  : 'Export an Excel report of customer work orders and their
            dispatched (shipped) weight.'
            }}
          </p>

          <div class="grid-auto-4">
            <!-- Customer (required) -->
            <div class="form-box">
              <label for="customer-order-report-customer">{{ 'CustomerOrderReport_Customer' | translateWF: 'Customer' }} *</label>
              <p-autocomplete
                inputId="customer-order-report-customer"
                formControlName="customer"
                [suggestions]="filteredCustomers()"
                (completeMethod)="filterCustomers($event)"
                optionLabel="name"
                [dropdown]="true"
                dropdownIcon="pi pi-search"
                [forceSelection]="true"
                [placeholder]="'CustomerOrderReport_Customer_Placeholder' | translateWF: 'Search customer'"
                fluid
                class="w-full"
                [ngClass]="{
                  'ng-invalid ng-dirty': reportForm.get('customer')?.invalid && reportForm.get('customer')?.touched,
                }"
              />
              <small class="p-error" *ngIf="reportForm.get('customer')?.invalid && reportForm.get('customer')?.touched">
                {{ 'CustomerOrderReport_Customer_Required' | translateWF: 'Please select a customer.' }}
              </small>
            </div>

            <!-- Creation date from (optional) -->
            <div class="form-box">
              <label for="customer-order-report-from">{{
                'CustomerOrderReport_Created_From'
                  | translateWF
                    : 'Created
                From'
              }}</label>
              <p-datepicker
                inputId="customer-order-report-from"
                formControlName="createdFrom"
                [iconDisplay]="'input'"
                [showIcon]="true"
                dateFormat="yy-mm-dd"
                fluid
                class="w-full"
              />
            </div>

            <!-- Creation date to (optional) -->
            <div class="form-box">
              <label for="customer-order-report-to">{{ 'CustomerOrderReport_Created_To' | translateWF: 'Created To' }}</label>
              <p-datepicker inputId="customer-order-report-to" formControlName="createdTo" [iconDisplay]="'input'" [showIcon]="true" dateFormat="yy-mm-dd" fluid class="w-full" />
            </div>
          </div>
        </p-card>
        <ng-template pTemplate="footer">
          <!-- Date range validation error (spans full width, shown below grid) -->
          <small class="p-error" *ngIf="reportForm.hasError('invalidDateRange') && reportForm.touched">
            {{
              'CustomerOrderReport_Invalid_Date_Range'
                | translateWF
                  : 'The "from" date must be on or before the "to"
            date.'
            }}
          </small>
          <!-- Detailed toggle -->
          @if (noResults()) {
            <div class="report-empty-state">
              <i class="pi pi-inbox"></i>
              <span>{{
                'CustomerOrderReport_NoResults_Detail'
                  | translateWF
                    : 'No work orders matched the selected
              filters.'
              }}</span>
            </div>
          }

          <div class="row-sm-start-center">
            <label for="customer-order-report-detailed">{{ 'CustomerOrderReport_Detailed' | translateWF: 'Detailed' }}</label>
            <p-toggleswitch inputId="customer-order-report-detailed" formControlName="detailed" />
            <small class="report-hint">
              {{
                'CustomerOrderReport_Detailed_Hint'
                  | translateWF
                    : 'Adds one sub-row per dispatch (number, date,
              weight).'
              }}
            </small>
          </div>
        </ng-template>
      </p-panel>
    </form>
  </div>
</main>
